// extracted by mini-css-extract-plugin
export var button = "_dg-7";
export var buttonRow = "_dg-6";
export var fadeIn = "_dg-1";
export var gradient = "_dg-0";
export var panel = "_dg-2";
export var panelIn = "_dg-3";
export var subtitle = "_dg-5";
export var title = "_dg-4";